<template>
  <TabelaOSD
    :colunas="resolvedColumns"
    :linhas="table.rows"
    :carregando="table.isLoading"
    :total-linhas="table.totalRows"
    :pagina="pagination.page"
    :campo-ordenacao="pagination.sort"
    :ordem-ordenacao="pagination.order"
    :texto-tabela-vazia="$t('indicadoresNaoEncontrados')"
    @page-change="onPageChange"
    @sort-change="onSortChange"
    @reload="getClientes"
  >
    <template #toolbar-actions>
      <ClientesExport v-bind="pagination" :headers="headers" />
    </template>
    <template #toolbar-filters>
      <ClientesFilters :loading="table.isLoading" @filter="onFilter" />
    </template>
  </TabelaOSD>
</template>

<script>
import ClientesExport from './ClientesExport.vue';
import ClientesFilters from './ClientesFilters.vue';
import TabelaOSD from '@/modules/shared/components/tabelaOSD/TabelaOSD.vue';
import { getPaginatedClientesData } from '../clientesService';
import { useToast } from 'vue-toastification';
import { toDate, toPhone } from '@/modules/core/utils/formats';
import { i18n } from '@/modules/localization';
import { ref, computed } from 'vue';

export default {
  components: { ClientesExport, ClientesFilters, TabelaOSD },
  data: () => ({
    table: {
      totalRows: 0,
      rows: [],
      columns: ref([
        {
          label: computed((_) => i18n.global.t('nome')),
          field: 'nome',
        }, {
          label: computed((_) => i18n.global.t('telefone')),
          field: 'telefone',
          formatFn: toPhone,
        }, {
          label: computed((_) => i18n.global.t('email')),
          field: 'email',
        },
        {
          label: computed((_) => i18n.global.t('dataHoraCriacao')),
          field: 'dataHoraCriacao',
          tdClass: 'text-break',
          formatFn: toDate,
        },
      ]),
      mode: 'remote',
      class: 'osd-table',
      styleClass: 'vgt-table bordered condensed',
      compactMode: true,
      lineNumbers: true,
      paginationOptions: {
        enabled: true,
        mode: 'pages',
        perPageDropdownEnabled: false,
        nextLabel: '>',
        prevLabel: '<',
        infoFn: (params) => `
      ${params.firstRecordOnPage} - ${params.lastRecordOnPage} de ${params.totalRecords}
      `,
      },
      sortOptions: {
        enabled: true,
        initialSortBy: { field: 'nome', type: 'desc' },
      },
      isLoading: false,
    },
    pagination: {
      page: 1,
      sort: 'nome',
      order: 'desc',
      search: '',
    },
  }),
  computed: {
    resolvedColumns() {
      return this.table.columns.map((column) => ({
        ...column,
        label: column.label?.value ?? column.label,
      }));
    },
    headers() { return this.resolvedColumns.map((column) => column.label); },
  },
  methods: {
    updateParams(pagination) {
      this.pagination = { ...this.pagination, ...pagination };
    },
    onPageChange(page) {
      this.updateParams({ page });
      this.getClientes();
    },
    onSortChange(field) {
      const nextOrder = this.pagination.sort === field && this.pagination.order === 'asc' ? 'desc' : 'asc';
      this.updateParams({
        page: 1,
        sort: field,
        order: nextOrder,
      });
      this.getClientes();
    },
    onFilter(filters) {
      this.updateParams({ ...filters, page: 1 });
      this.getClientes();
    },
    async getClientes() {
      this.table.isLoading = true;
      try {
        const data = await getPaginatedClientesData(this.pagination);
        this.table.rows = data.dados;
        this.table.totalRows = data.total;
      } catch (error) {
        useToast().error(ref(computed((_) => i18n.global.t('erroAoObterAsInfosDosClientes'))));
      }
      this.table.isLoading = false;
    },
  },
};

</script>
